import React from 'react';
import YoutubeChannelsApi from '../../components/admin/YoutubeChannelsApi';

const YoutubeChannelsApiPage = () => {
  return <YoutubeChannelsApi />;
};

export default YoutubeChannelsApiPage;
